<mat-sidenav-container darkModeSupport>
  @if (!mobileView) {
    <mat-sidenav
      #sidenav
      class=""
      mode="side"
      disableClose="true"
      [opened]="true"
      [ngClass]="{ closed: !sidenavOpened }"
    >
      <div class="mat-sidenav-wrapper">
        <div class="sidenav-header">
          @if (sidenavOpened) {
            <img class="logo" darkModeSupport src="assets/branding/images/logo_long.svg" />
            <mat-icon (click)="sidenavOpened = false">keyboard_double_arrow_left</mat-icon>
          } @else {
            <mat-icon (click)="sidenavOpened = true">keyboard_double_arrow_right</mat-icon>
          }
        </div>

        <div class="sidenav-scrollable-content">
          @if (userRole !== UserRole.MSP || selectedCompany) {
            <a mat-button class="route" [ngClass]="{ closed: !sidenavOpened }" (click)="addNew()">
              <mat-icon class="route-icon">add</mat-icon>
              @if (sidenavOpened) {
                <span class="route-text">{{ 'NAVBAR.ADD_NEW' | translate }}</span>
              }
            </a>

            <mat-divider></mat-divider>
          }

          @for (route of routes; track route) {
            <div class="route-wrapper">
              <a
                mat-button
                class="route"
                routerLinkActive="active"
                [routerLink]="route.path"
                [ngClass]="{ closed: !sidenavOpened }"
              >
                <mat-icon class="route-icon">{{ route.icon }}</mat-icon>
                @if (sidenavOpened) {
                  <span
                    [matBadge]="routeBadgeData.get(route.badgeData)"
                    [matBadgeHidden]="!route.badgeData || routeBadgeData.get(route.badgeData) === 0"
                    matBadgeSize="medium"
                    [ngClass]="route.badgeData"
                    class="route-text"
                  >
                    {{ route.text || '' | translate }}
                  </span>
                }
              </a>
            </div>
          }
        </div>

        <div class="sidenav-footer">
          <a
            mat-button
            class="route"
            routerLink="settings"
            routerLinkActive="active"
            [ngClass]="{ closed: !sidenavOpened }"
          >
            <mat-icon class="route-icon">settings</mat-icon>
            @if (sidenavOpened) {
              <span class="route-text">{{ 'NAVBAR.SETTINGS' | translate }}</span>
            }
          </a>
          <a mat-button class="route" [ngClass]="{ closed: !sidenavOpened }" (click)="logout()">
            <mat-icon class="route-icon">logout</mat-icon>
            @if (sidenavOpened) {
              <span class="route-text">
                {{ 'NAVBAR.LOGOUT' | translate }}
              </span>
            }
          </a>
        </div>
      </div>
    </mat-sidenav>
  }
  <mat-sidenav-content class="content" [ngClass]="{ closed: !sidenavOpened && !mobileView }">
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
